import type { JSX } from 'react';
import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { Container, TabItem, Tabs } from '../../ui/layout/TabContent.tsx';
import { collectionTexts, tomTexts } from '../i18n/TomTexts.ts';
import * as TomLayoutState from '../state/TomLayoutState.ts';
import { TomsBody } from './TomsBody.tsx';
import { CollectionsBody } from './collection/CollectionsBody.tsx';
import * as CurrentOperatorLoginState from '../../common/state/CurrentOperatorLoginState.ts';
import { isUndefined } from 'dg-web-shared/lib/MaybeV2.ts';

function RenderTabBody({
    activeTab,
}: {
    activeTab: TomLayoutState.Tabs;
}): JSX.Element | null {
    switch (activeTab) {
        case TomLayoutState.Tabs.TOM:
            return <TomsBody />;
        case TomLayoutState.Tabs.Collections:
            return <CollectionsBody />;
        default:
            return null;
    }
}

export function TomsOverview() {
    const { storeState, update } = useStore(store => ({
        currentLogin: CurrentOperatorLoginState.get(store),
        layout: TomLayoutState.SelectedTab.get(store),
    }));
    const { language } = useLanguage();

    const texts = tomTexts[language];
    const layout = storeState.layout;
    if (isUndefined(storeState.currentLogin.data)) {
        return null;
    }

    return (
        <Container>
            <Tabs>
                <TabItem
                    active={layout.activeTab === TomLayoutState.Tabs.TOM}
                    description={texts.TabTitle()}
                    onClick={() =>
                        update(store =>
                            TomLayoutState.SelectedTab.stateWrite(store, {
                                activeTab: TomLayoutState.Tabs.TOM,
                            }),
                        )
                    }
                />
                <TabItem
                    active={
                        layout.activeTab === TomLayoutState.Tabs.Collections
                    }
                    description={collectionTexts[language].TabTitle()}
                    onClick={() =>
                        update(store =>
                            TomLayoutState.SelectedTab.stateWrite(store, {
                                activeTab: TomLayoutState.Tabs.Collections,
                            }),
                        )
                    }
                />
            </Tabs>
            <RenderTabBody activeTab={layout.activeTab} />
        </Container>
    );
}
